import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import ExcelIcon from "./../../../Assests/excel.svg";
import DownloadIcon from "./../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import axios from "axios";
import FileSaver from "file-saver";
import {
  Box,
  List,
  ListItem,
  FormControlLabel,
  Snackbar,
  Alert,
  CircularProgress,
  Tooltip,
  AlertProps,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  API_BASE_URL,
  LONG_DYNAMIC_CONSTRAINS_API,
  LONG_DYNAMIC_CONSTRAINS_CRITERIA_API,
  LONG_DYNAMIC_CONSTRAINS_DELETE_API,
  LONG_DYNAMIC_CONSTRAINS_GETALL_API,
  LONG_DYNAMIC_CONSTRAINS_GETALL_CR1WITHTYPE_API,
  LONG_DYNAMIC_CONSTRAINS_SAVE_API,
  LONG_DYNAMIC_CONSTRAINS_UPDATE_API,
  LONG_DYNAMIC_CONSTRAINS_UPDATE_BY_ID_API,
  DOWNLOAD_DC_TEMPLATE_API,
  UPLOAD_DC_API,
} from "../../../Utils/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../../../Services/AxiosConfiguration";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  DataGrid,
  GridColDef,
  GridPagination,
  GridPreProcessEditCellProps,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import MuiPagination from "@mui/material/Pagination";
import { TablePaginationProps } from "@mui/material/TablePagination";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

let initialStateArr: any = [
  {
    contstrainNames: [],
    contstrainValue: "",
    criteriaOne: [],
    criteriaOneV: "",
    criTypeName: "",
    criteriaTwoType: [],
    criteriaTwo: [],
    criteriaTwoV: [],
    value: "",
    cu: "",
    sign: [],
    signValue: "",
    time_Period: [],
    time_PeriodV: "",
    cuFlag: [],
  },
];

let dynamicConstrainMain: any = [
  {
    contstrainNames: [],
    contstrainValue: "",
    criteriaOne: [],
    criteriaOneV: "",
    criTypeName: "",
    criteriaTwoType: [],
    criteriaTwo: [],
    criteriaTwoV: [],
    value: "",
    cu: "",
    sign: [],
    signValue: "",
    time_Period: [],
    time_PeriodV: "",
    cuFlag: [],
  },
];

let contstrainNameValue = "";
let isContstrainNameChanged = true;
let CritriaTwoTypeVal = "";
let criteriaDisable = false;
let constrainId = "";
let deleteInMainId = "";
let editedC1Array: any = [];
let editedC2Array: any = [];
let editedTimeArray: any = [];
let setCcidForEdit: any = "";
let criteria2Edit: any = [];
let time_PeriodEdit: any = [];

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function DynamicConstrains(props: any) {
  const [getAddData, setAddData] = React.useState(true);
  const [getNewAddData, setNewAddData] = React.useState(false);
  const [getDynamicConstrainMain, setDynamicConstrainMain] =
    React.useState<any>([]);
  const [personName, setPersonName] = React.useState<any>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");
  const [criteriaName, setCriteriaName] = React.useState<string[]>([]);
  const [getContstrainName, setContstrainName] = React.useState("");
  const [getContstrainIndex, setContstrainIndex] = React.useState<any>();
  const [focusedField, setFocusedField] = useState(null);

  const [getSignName, setSignName] = React.useState("");
  const [getValueName, setValueName] = React.useState("");
  const [getCuName, setCuName] = React.useState("");
  const [getFolderName, setFolderName] = React.useState<any>(null);
  const [showEmptyPage, setEmptyPage] = useState(true);
  const [disableSave, setDisableSave] = useState<any>(false);
  const [getAddNewFlag, setAddNewFlag] = useState<any>(false);

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [rowCount, setRowCount] = React.useState(0);
  const [selectedCritriaOne, setSelectedCritriaOne] = useState<any>([]);
  const [selectedCritriaTwo, setSelectedCritriaTwo] = useState<any>([]);

  const [selectedTimePeriod, setSelectedTimePeriod] = useState<any>([]);
  const [getAllConstarins, setAllConstarins] = React.useState<any>([]);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [getDataForEdit, setDataForEdit] = React.useState<any>([]);
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const [headingName, setHeadingName] = React.useState("Dynamic Constraint");
  const [getCriteriaOneEdited, setCriteriaOneEdited] = React.useState<any>([]);
  const [getCriteriaTwoEdited, setCriteriaTwoEdited] = React.useState<any>([]);
  const [getTimePeriodEdited, setTimePeriodEdited] = React.useState<any>([]);

  // const [getConstrainData, setConstrainData] = React.useState<string[]>([])

  // const handleSelectAll = () => {
  //   if (selectAll) {
  //     setPersonName([]);
  //   } else {
  //     setPersonName(names);
  //   }
  //   setSelectAll(!selectAll);
  // };

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  const handleGetAllConstarins = async () => {
    setIsLoading(true);
    let getFNameVal: any = gerFolderName();
    let folderModuleName = selectedFolderData?.folder?.slice(0, 7);

    let moduleNumber = folderModuleName
      ? folderModuleName.toLowerCase().replace("module", "")
      : "";

    const requestParam = {
      folder_id: selectedFolderId, //4
      scenario_id: selectedScenarioId, //27
      moduleKey: moduleNumber,
    };
    const urls = API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_GETALL_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    if (moduleNumber !== "") {
      await postRequest(urls, requestParam, header, {})
        .then((response) => {
          if (response.status === 200 && response.data) {
            setAllConstarins(response.data);
            setIsLoading(false);
            setEmptyPage(false);
            setNewAddData(false);
            if (response.data.length == 0) {
              setHeadingName("Dynamic Constraint");
              setEmptyPage(true);
            } else {
              setHeadingName("Dynamic Constraint");
            }
          }
        })
        .catch((error) => {
          errorMessagehandler();
        });
    }
    setIsLoading(false);
  };

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );
  useEffect(() => {
    let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
    if (folderModuleName && selectedScenarioId !== 0) {
      handleGetAllConstarins();
      setOpenEdit(false);
      setDynamicConstrainMain(initialStateArr);
    }
  }, [selectedFolderId, selectedScenarioId]);

  useEffect(() => {}, [getContstrainIndex, selectedScenarioId]);

  const gerFolderName = () => {
    let fname =
      localStorage.getItem("folderName") == "undefined" ||
      localStorage.getItem("folderName") == ""
        ? null
        : localStorage.getItem("folderName");
    return fname;
  };

  // show error message

  const successMessagehandler = (message: any) => {
    setIsLoading(false);

    setSnackbar({
      children: message,
      severity: "success",
    });
  };

  const errorMessagehandler = () => {
    setIsLoading(false);

    setSnackbar({
      children: "Something went wrong please try again !",
      severity: "error",
    });
  };

  const toggleDisplay = (addFlag: any) => {
    if (addFlag) {
      setAddNewFlag(addFlag);
      setAllConstarins([]);
      dynamicConstrainMain[0].contstrainNames.length = 0;
    }

    // fetchModuleId()
    let getFNameVal = gerFolderName();
    let folderModuleName = selectedFolderData?.folder?.slice(0, 7);

    if (folderModuleName && selectedScenarioId !== 0) {
      setEmptyPage(false);
      setAddData(false);
      setNewAddData(true);
      setDisableSave(true);
      toggleNewDisplay();
    } else {
      setIsLoading(false);

      setSnackbar({
        children: "Please choose a valid Module/Folder id..!",
        severity: "error",
      });
    }
  };
  const hiddenFileInput = useRef<HTMLInputElement | null>(null);
  const handleUploadConstraintClick = () => {
    const folderModuleName = selectedFolderData?.folder?.slice(0, 7);
    if (folderModuleName && selectedScenarioId !== 0) {
      hiddenFileInput.current?.click();
    } else {
      setIsLoading(false);
      setSnackbar({
        children: "Please choose a valid Module/Folder id and Scenario.",
        severity: "error",
      });
    }
  };
  const handleUploadConstraintFile = async (event: any) => {
    const file = event.target.files[0];
    const folderModuleName = selectedFolderData?.folder?.slice(0, 7);
    console.log(
      folderModuleName,
      selectedScenarioId,
      file,
      "selectedFolderData",
    );
    if (file && folderModuleName && selectedScenarioId !== 0) {
      setIsLoading(true);

      // Build FormData
      const formData = new FormData();
      formData.append("file", file);

      // Build query parameters
      const params = {
        usecase: "longterm",
        category: folderModuleName.toLowerCase(),
        filetype: folderModuleName.toLowerCase(),
        folderid: selectedFolderId,
        scenarioid: selectedScenarioId,
      };

      // API endpoint
      const urls = API_BASE_URL + UPLOAD_DC_API;

      // Headers for multipart/form-data
      const header = {
        accept: "*/*",
        "Content-Type": "multipart/form-data",
      };

      try {
        await postRequest(urls, formData, header, params, true)
          .then((response: any) => {
            if (response.status === 200) {
              setIsLoading(false);
              setSnackbar({
                children: "File uploaded successfully",
                severity: "success",
              });
              // Refresh the constraints list after successful upload
              handleGetAllConstarins();
              // Reset file input
              if (hiddenFileInput.current) {
                hiddenFileInput.current.value = "";
              }
            }
          })
          .catch((error: any) => {
            const errors = error?.response?.data?.errors;
            const msg = Array.isArray(errors)
              ? errors.join("\n")
              : errors || "File upload failed";
            console.log(error, "error11");
            setIsLoading(false);
            setSnackbar({
              children: msg || "File upload failed",
              severity: "error",
            });
          });
      } catch (error: any) {
        setIsLoading(false);
        setSnackbar({
          children: "An error occurred while uploading the file",
          severity: "error",
        });
      }
    } else {
      setSnackbar({
        children:
          "Please select a file and ensure folder and scenario are selected",
        severity: "error",
      });
    }
  };

  const toggleNewDisplay = async () => {
    setIsLoading(true);
    // get f name

    let fname = gerFolderName();
    let responsedata: any = [];

    if (fname == null || fname == undefined) {
      return;
    }

    if (fname !== null) {
      // if (dynamicConstrainMain[0].contstrainNames.length === 0) {
      // get - constarins

      const urls = API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      await getRequest(urls, { ModuleKey: `${fname}` }, header)
        .then((response: any) => {
          if (response.status === 200 && response.data) {
            responsedata = response.data;
            setRowCount(0);
            setIsLoading(false);
            setHeadingName("Create Dynamic Constraint");
          }
        })
        .catch((error) => {
          errorMessagehandler();
        });
      const objIndex = 0;

      // make new object of updated object.
      const updatedObj = {
        ...dynamicConstrainMain[objIndex],
        contstrainNames: responsedata,
      };

      // make final new array of objects by combining updated object.
      const updatedProjects: any = [
        ...dynamicConstrainMain.slice(0, objIndex),
        updatedObj,
        ...dynamicConstrainMain.slice(objIndex + 1),
      ];

      dynamicConstrainMain = updatedProjects;

      setDynamicConstrainMain(updatedProjects);
      // }
      // else {
      //   let count = rowCount + 1;
      //   setRowCount(count);
      //   //find the index of object from array that you want to update
      //   const objIndex = count;

      //   // // make new object of updated object.
      //   // const updatedObj = {
      //   //   ...dynamicConstrainMain[objIndex],
      //   //   contstrainNames: responsedata,
      //   // }

      //   // // make final new array of objects by combining updated object.
      //   // const updatedProjects: any = [
      //   //   ...dynamicConstrainMain.slice(0, objIndex),
      //   //   updatedObj,
      //   //   ...dynamicConstrainMain.slice(objIndex + 1),
      //   // ]

      //   // dynamicConstrainMain = updatedProjects

      //   let addNewConstrains =
      //     getDynamicConstrainMain.concat(dynamicConstrainMain);
      //   setDynamicConstrainMain(addNewConstrains);
      // }
    }
  };

  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value,
    );
  };

  const handleCriteriaChange = (
    event: SelectChangeEvent<typeof criteriaName>,
  ) => {
    const {
      target: { value },
    } = event;
    setCriteriaName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value,
    );
  };
  const handleSelectAll = (event: any, values: any) => {
    if (event.target.checked) {
      // setPersonName(criteriaOne)
    } else {
      setPersonName([]);
    }
  };

  const autoClearCriteriaOne = useRef<any>(null);
  const autoClearCriteriaTwo = useRef<any>(null);
  const autoClearTimePeriod = useRef<any>(null);

  const getCriteriaModuleDetails = async (lableId: any) => {
    setIsLoading(true);
    let getFNameVal = gerFolderName();
    constrainId = lableId;

    // clear autocomplete values
    let criteriaOne = autoClearCriteriaOne.current.getElementsByClassName(
      "MuiAutocomplete-clearIndicator",
    )[0];

    let criteriaTwo = autoClearCriteriaTwo.current.getElementsByClassName(
      "MuiAutocomplete-clearIndicator",
    )[0];

    let timePeriod = autoClearTimePeriod.current.getElementsByClassName(
      "MuiAutocomplete-clearIndicator",
    )[0];

    if (criteriaOne) criteriaOne.click(); // clear criteria 1

    if (criteriaTwo) criteriaTwo.click(); // clear criteria 2
    if (timePeriod) timePeriod.click(); // clear time period

    if (lableId && getFNameVal && selectedFolderId) {
      let bodyObject = {
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        moduleKey: `${getFNameVal}`,
        constrain_Id: lableId,
      };

      let responsedata: any = [];
      const urls = API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_CRITERIA_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      await postRequest(urls, bodyObject, header)
        .then((response: any) => {
          if (response.status === 200 && response.data) {
            responsedata = response.data;
            setIsLoading(false);
          }
        })
        .catch((error) => {
          errorMessagehandler();
        });

      //find the index of object from array that you want to update
      const objIndex = rowCount;

      // // make new object of updated object.
      const updatedObj = {
        ...getDynamicConstrainMain[objIndex],
        criteriaOne: responsedata.criteriaOne ? responsedata.criteriaOne : [],
        criteriaTwo: responsedata.criteriaTwo ? responsedata.criteriaTwo : [],
        criteriaTwoType: responsedata.criteriaTwo_Type
          ? responsedata.criteriaTwo_Type
          : [],
        cuFlag:
          responsedata.cuFlag[0]["cuFlag_Value"] !== "NA"
            ? responsedata.cuFlag[0]["cuFlag_Value"]
            : responsedata.cuFlag[0]["cuFlag_Value"],
        sign: responsedata.sign ? responsedata.sign : "",
        time_Period: responsedata.time_Period ? responsedata.time_Period : [],
        contstrainValue: contstrainNameValue
          ? contstrainNameValue
          : getContstrainName,
        criTypeName: CritriaTwoTypeVal ? CritriaTwoTypeVal : "",
      };

      // make final new array of objects by combining updated object.
      const updatedProjects: any = [
        ...getDynamicConstrainMain.slice(0, objIndex),
        updatedObj,
        ...getDynamicConstrainMain.slice(objIndex + 1),
      ];

      // let addNewConstrains = getDynamicConstrainMain.concat(updatedProjects)

      setDynamicConstrainMain(updatedProjects);
    }
  };

  const getCriteriaOneVal = (list: any, value: any) => {
    return list.replace(new RegExp(",?" + value + ",?"), (match: any) => {
      var first_comma = match.charAt(0) === ",",
        second_comma;

      if (
        first_comma &&
        (second_comma = match.charAt(match.length - 1) === ",")
      ) {
        return ",";
      }
      return "";
    });
  };

  const getAllWithC1AndCtypw = async (key: any, val: any) => {
    setIsLoading(true);
    let getFNameVal = gerFolderName();

    if (
      key &&
      val &&
      getFNameVal &&
      selectedFolderId &&
      selectedCritriaOne &&
      selectedCritriaOne.length !== 0
    ) {
      let array = selectedCritriaOne
        .map((e: any) => {
          let body;
          if (e.criteria_1_Value.includes("Vendor_Code")) {
            body = e.criteria_1_Value.replace("Vendor_Code:", "");
          } else if (e.criteria_1_Value.includes("Processing_Plant_Code")) {
            body = e.criteria_1_Value.replace("Processing_Plant_Code:", "");
          } else if (e.criteria_1_Value.includes("Demand_Location_Code")) {
            body = e.criteria_1_Value.replace("Demand_Location_Code:", "");
          } else if (e.criteria_1_Value.includes("Packaging_Plant_Code")) {
            body = e.criteria_1_Value.replace("Packaging_Plant_Code:", "");
          }
          return body;
        })
        .join(",");

      let bodyObject = {
        folder_id: selectedFolderId, //4
        scenario_id: selectedScenarioId, //27
        moduleKey: `${getFNameVal}`,
        constrain_Id: constrainId,
        criteria_1_Value: array, //'VENDOR001', // array,
        criteria_2_Type: key,
        criteria_2_Value: "", // val,
      };

      let responsedata: any = [];
      const urls =
        API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_GETALL_CR1WITHTYPE_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      await postRequest(urls, bodyObject, header)
        .then((response: any) => {
          if (response.status === 200 && response.data) {
            responsedata = response.data;
            setIsLoading(false);
          }
        })
        .catch((error) => {
          errorMessagehandler();
        });

      //find the index of object from array that you want to update
      const objIndex = rowCount;

      // // make new object of updated object.
      const updatedObj = {
        ...getDynamicConstrainMain[objIndex],
        criteriaTwo: responsedata.criteriaTwo ? responsedata.criteriaTwo : [],
        time_Period: responsedata.time_Period ? responsedata.time_Period : [],
        criTypeName: key,
      };

      // make final new array of objects by combining updated object.
      const updatedProjects: any = [
        ...getDynamicConstrainMain.slice(0, objIndex),
        updatedObj,
        ...getDynamicConstrainMain.slice(objIndex + 1),
      ];

      // let addNewConstrains = getDynamicConstrainMain.concat(updatedProjects)

      setDynamicConstrainMain(updatedProjects);
    }
    setIsLoading(false);
  };

  const handleConstrainData = async (event: any, ind: any) => {
    const {
      target: { value, id },
    } = event;

    //find the index of object from array that you want to update
    const objIndex = getDynamicConstrainMain.findIndex(
      (obj: any, i: any) => ind === i,
    );

    // Make sure to avoid incorrect replacement
    // When specific item is not found
    if (objIndex === -1) {
      return;
    }

    // make new object of updated object.
    const updatedObj = {
      ...getDynamicConstrainMain[objIndex],
      contstrainValue: value,
    };
    contstrainNameValue = value;
    criteriaDisable = false;

    if (contstrainNameValue !== value) {
      isContstrainNameChanged = false;
    }

    setContstrainName(value);

    // make final new array of objects by combining updated object.
    const updatedProjects: any = [
      ...getDynamicConstrainMain.slice(0, objIndex),
      updatedObj,
      ...getDynamicConstrainMain.slice(objIndex + 1),
    ];

    setDynamicConstrainMain(updatedProjects);
  };

  const handleCriteriaType2Data = async (event: any, ind: any) => {
    const {
      target: { value, id },
    } = event;

    //find the index of object from array that you want to update
    const objIndex = getDynamicConstrainMain.findIndex(
      (obj: any, i: any) => ind === i,
    );

    // Make sure to avoid incorrect replacement
    // When specific item is not found
    if (objIndex === -1) {
      return;
    }

    // make new object of updated object.
    const updatedObj = {
      ...getDynamicConstrainMain[objIndex],
      criTypeName: value,
    };

    CritriaTwoTypeVal = value;

    // make final new array of objects by combining updated object.
    const updatedProjects: any = [
      ...getDynamicConstrainMain.slice(0, objIndex),
      updatedObj,
      ...getDynamicConstrainMain.slice(objIndex + 1),
    ];

    setDynamicConstrainMain(updatedProjects);
  };

  const handleSetIndForConstarin = async (event: any, lableId: any) => {
    const {
      target: { value, id },
    } = event;
    setContstrainIndex(lableId);
    await getCriteriaModuleDetails(lableId);
  };

  const handleCriteriaType2DataClick = async (
    event: any,
    key: any,
    val: any,
  ) => {
    const {
      target: { value, id },
    } = event;

    let criteriaTwo = autoClearCriteriaTwo.current.getElementsByClassName(
      "MuiAutocomplete-clearIndicator",
    )[0];
    if (criteriaTwo) criteriaTwo.click(); // clear criteria 2

    await getAllWithC1AndCtypw(key, val);
  };

  const handleCriteriaType2DataClickEdit = async (
    event: any,
    key: any,
    val: any,
  ) => {
    const {
      target: { value, id },
    } = event;

    let criteriaTwo = autoClearCriteriaTwo.current.getElementsByClassName(
      "MuiAutocomplete-clearIndicator",
    )[0];
    if (criteriaTwo) criteriaTwo.click(); // clear criteria 2

    await getAllWithC1AndCtypwForEdit(key, val);
  };

  const SelectContstrain = (
    templateData: any,
    index: any,
    nameTemplateData: any,
  ) => {
    return (
      <Select
        id="simple-select-constrain"
        value={nameTemplateData}
        onChange={(event) => handleConstrainData(event, index)}
        label="Select Constraint Type"
        inputProps={{ "aria-label": "Without label" }}
        displayEmpty
      >
        <MenuItem>
          <em>Select Constraint Type</em>
        </MenuItem>
        {templateData.map((d: any, ind: any) => {
          return (
            <MenuItem
              key={`cont-list-${ind}`}
              id={ind}
              onClick={(e) => handleSetIndForConstarin(e, d.id)}
              value={d.constrainName}
            >
              {d.constrainName}
            </MenuItem>
          );
        })}
      </Select>
    );
  };

  //--------------------------------- sign flow

  const handleSignData = (event: any, ind: any) => {
    const {
      target: { value },
    } = event;

    //find the index of object from array that you want to update
    const objIndex = getDynamicConstrainMain.findIndex(
      (i: any) => ind === rowCount,
    );

    // Make sure to avoid incorrect replacement
    // When specific item is not found
    if (objIndex === -1) {
      return;
    }

    // make new object of updated object.
    const updatedObj = {
      ...getDynamicConstrainMain[objIndex],
      signValue: value,
    };

    // make final new array of objects by combining updated object.
    const updatedProjects: any = [
      ...getDynamicConstrainMain.slice(0, objIndex),
      updatedObj,
      ...getDynamicConstrainMain.slice(objIndex + 1),
    ];

    setDynamicConstrainMain(updatedProjects);

    setSignName(value);
  };

  //------------------------------- value flow

  const handleValueChange = (event: any, index: any) => {
    const {
      target: { value, id },
    } = event;

    //find the index of object from array that you want to update
    const objIndex = getDynamicConstrainMain.findIndex(
      (obj: any, i: any) => index === i,
    );

    setFocusedField(id);

    // Make sure to avoid incorrect replacement
    // When specific item is not found
    if (objIndex === -1) {
      return;
    }

    // make new object of updated object.
    const updatedObj = { ...getDynamicConstrainMain[objIndex], value: value };

    // make final new array of objects by combining updated object.
    const updatedProjects: any = [
      ...getDynamicConstrainMain.slice(0, objIndex),
      updatedObj,
      ...getDynamicConstrainMain.slice(objIndex + 1),
    ];

    setDynamicConstrainMain(updatedProjects);

    setValueName(value);
  };

  //-------------------------------- cu flow

  const handleCuChange = (event: any, index: any) => {
    const {
      target: { value, id },
    } = event;

    //find the index of object from array that you want to update
    const objIndex = getDynamicConstrainMain.findIndex(
      (obj: any, i: any) => index === i,
    );

    setFocusedField(id);

    // Make sure to avoid incorrect replacement
    // When specific item is not found
    if (objIndex === -1) {
      return;
    }

    // make new object of updated object.
    const updatedObj = {
      ...getDynamicConstrainMain[objIndex],
      cu: value,
      cuFlag: value,
    };

    // make final new array of objects by combining updated object.
    const updatedProjects: any = [
      ...getDynamicConstrainMain.slice(0, objIndex),
      updatedObj,
      ...getDynamicConstrainMain.slice(objIndex + 1),
    ];

    setDynamicConstrainMain(updatedProjects);

    setCuName(value);
  };

  const getCriteria2DetailsC1 = () => {};

  const handleChangeCriteriaOne = (e: any, v: any) => setSelectedCritriaOne(v);

  const handleChangeCriteriaTwo = (e: any, v: any) => setSelectedCritriaTwo(v);
  const handleChangeTimePeriod = (e: any, v: any) => setSelectedTimePeriod(v);

  const CheckboxesTagsCriteriaOne = (criteriaOneData: any) => {
    criteriaDisable = false;
    if (criteriaOneData) {
      let checkNa = criteriaOneData[0];

      if (checkNa?.criteria_2_Value == "NA") {
        criteriaDisable = true;
      }
    }
    if (criteriaOneData.length == 0) {
      criteriaDisable = true;
    }
    return (
      <Autocomplete
        multiple
        id="checkboxes-tags-demo-new"
        //open
        options={criteriaOneData}
        limitTags={1}
        onChange={handleChangeCriteriaOne}
        disabled={criteriaDisable}
        ref={autoClearCriteriaOne}
        value={selectedCritriaOne}
        autoComplete
        includeInputInList
        disableCloseOnSelect
        getOptionLabel={(option: any) => option.criteria_1_Key}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox checked={selected} />
            {option.criteria_1_Key}
          </li>
        )}
        // style={{ width: 500 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select Criteria 1"
            fullWidth
          />
        )}
      />
    );
  };

  const CheckboxesTagsCriteriaTwoType = (
    templateData: any,
    index: any,
    nameTemplateData: any,
  ) => {
    criteriaDisable = false;
    if (templateData) {
      let checkNa = templateData[0];

      if (checkNa?.criteria_2_Value == "NA") {
        criteriaDisable = true;
      }
    }
    if (templateData.length == 0) {
      criteriaDisable = true;
    }
    return (
      <Select
        id="simple-select-constrain"
        value={nameTemplateData}
        disabled={criteriaDisable}
        onChange={(event) => handleCriteriaType2Data(event, index)}
        inputProps={{ "aria-label": "Without label" }}
        displayEmpty
      >
        <MenuItem>
          <em>Select Constraint Type</em>
        </MenuItem>
        {templateData.map((d: any, ind: any) => {
          return (
            <MenuItem
              key={`cont-list-type-${ind}`}
              id={ind}
              onClick={(e) =>
                handleCriteriaType2DataClick(
                  e,
                  d.criteria_2_Key,
                  d.criteria_2_Value,
                )
              }
              value={d.criteria_2_Value}
            >
              {d.criteria_2_Value}
            </MenuItem>
          );
        })}
      </Select>
    );
  };

  const CheckboxesTagsCriteriaTwo = (criteriaTwoData: any) => {
    let disable = false;
    if (criteriaTwoData) {
      let checkNa = criteriaTwoData[0];

      if (checkNa?.criteria_2_Value == "NA") {
        disable = true;
      }
    }
    if (criteriaTwoData.length == 0) {
      disable = true;
    }

    return (
      <Autocomplete
        multiple
        id="checkboxes-tags-demo-new"
        options={criteriaTwoData}
        limitTags={1}
        disabled={criteriaDisable || disable}
        onChange={handleChangeCriteriaTwo}
        value={selectedCritriaTwo}
        ref={autoClearCriteriaTwo}
        // disabled={!inputValue ? true : false}
        autoComplete
        includeInputInList
        disableCloseOnSelect
        getOptionLabel={(option: any) => option.criteria_2_Key}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox checked={selected} />
            {option.criteria_2_Key}
          </li>
        )}
        // style={{ width: 500 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select Criteria 2"
            fullWidth
          />
        )}
      />
    );
  };

  const TimePeriodData = (timePeriodData: any) => {
    let disable = false;
    if (timePeriodData) {
      let checkNa = timePeriodData[0];

      if (checkNa?.criteria_2_Value == "NA") {
        disable = true;
      }
    }
    if (timePeriodData.length == 0) {
      disable = true;
    }
    return (
      <Autocomplete
        multiple
        id="checkboxes-tags-demo-new"
        options={timePeriodData}
        limitTags={1}
        disableCloseOnSelect
        onChange={handleChangeTimePeriod}
        disabled={disable}
        ref={autoClearTimePeriod}
        value={selectedTimePeriod}
        autoComplete
        includeInputInList
        getOptionLabel={(option: any) => option.time_Period_Key}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox checked={selected} />
            {option.time_Period_Key}
          </li>
        )}
        // style={{ width: 500 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select TimePeriod"
            fullWidth
          />
        )}
      />
    );
  };

  const SignNames = (getSignNameData: any, index: any) => {
    return (
      <Select
        id="simple-select-constrain"
        value={getSignNameData.signValue}
        onChange={(e) => handleSignData(e, index)}
        inputProps={{ "aria-label": "Without label" }}
        displayEmpty
      >
        <MenuItem>
          <em>Select Sign</em>
        </MenuItem>
        {getSignNameData?.map((d: any, ind: any) => {
          return (
            <MenuItem key={`sign-list-${ind}`} value={d.symbol_Key}>
              {d.symbol_Key}
            </MenuItem>
          );
        })}
      </Select>
    );
  };

  // show error message

  const [open, setOpen] = React.useState(false);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }
  };

  // save constrain

  const handleSaveConstraint = async () => {
    if (!getSignName) {
      setSnackbar({
        children: "Please choose a Sign value..!",
        severity: "error",
      });
    } else {
      setIsLoading(true);
      const objIndex = rowCount;
      let getFNameVal = gerFolderName();
      let arrayCrit_1 = "";
      let arrayCrit_2 = "";
      let time_period = "";
      let gurubi1Flag = "";
      let gurubi2Flag = "";
      let gurubiOne: any = {};
      let gurubiTwo: any = {};

      // codes for crit 1

      let vc = "Vendor_Code";
      let ppc = "Processing_Plant_Code";
      let dlc = "Demand_Location_Code";
      let pacc = "Packaging_Plant_Code";

      if (selectedCritriaOne && selectedCritriaOne.length !== 0) {
        console.log(selectedCritriaOne, "selectedCritriaOne");
        arrayCrit_1 = await selectedCritriaOne
          .map((e: any) => {
            let body;
            let value1 = e.criteria_1_Value;
            if (value1.includes(vc)) {
              body = value1.replace("Vendor_Code:", "");
              gurubi1Flag = vc;
            } else if (value1.includes(ppc)) {
              body = value1.replace("Processing_Plant_Code:", "");
              gurubi1Flag = ppc;
            } else if (value1.includes(dlc)) {
              body = value1.replace("Demand_Location_Code:", "");
              gurubi1Flag = dlc;
            } else if (value1.includes(pacc)) {
              body = value1.replace("Packaging_Plant_Code:", "");
              gurubi1Flag = pacc;
            } else {
              body = value1;
            }
            return body;
          })
          .join(",");

        let C1Gub = arrayCrit_1.split(",");
        if (gurubi1Flag) {
          gurubiOne[gurubi1Flag] = C1Gub;
        }
      }

      let fc = "Facility_Code";
      let rpmc = "RM_PM_MI_Code";
      let dml = "Demand_location_Code";
      let ccd = "Cascade";
      let sfgc = "SFG_Code";
      let pc = "Product_Code";

      if (selectedCritriaTwo && selectedCritriaTwo.length !== 0) {
        arrayCrit_2 = await selectedCritriaTwo
          .map((e: any) => {
            let body;
            let value = e.criteria_2_Value;
            if (value.includes(fc)) {
              body = value.replace("Facility_Code:", "");
              gurubi2Flag = fc;
            } else if (value.includes(rpmc)) {
              body = value.replace("RM_PM_MI_Code:", "");
              gurubi2Flag = rpmc;
            } else if (value.includes(dml)) {
              body = value.replace("Demand_location_Code:", "");
              gurubi2Flag = dml;
            } else if (value.includes(ccd)) {
              body = value.replace("Cascade:", "");
              gurubi2Flag = ccd;
            } else if (value.includes(sfgc)) {
              body = value.replace("SFG_Code:", "");
              gurubi2Flag = sfgc;
            } else if (value.includes(pc)) {
              body = value.replace("Product_Code:", "");
              gurubi2Flag = pc;
            } else if (value.includes(pacc)) {
              body = value.replace("Packaging_Plant_Code:", "");
              gurubi2Flag = pacc;
            } else {
              body = value;
            }
            return body;
          })
          .join(",");

        let C2Gub = arrayCrit_2.split(",");
        if (gurubi2Flag) {
          gurubiTwo[gurubi2Flag] = C2Gub;
        }
      }

      let timeArr: any = [];
      if (selectedTimePeriod && selectedTimePeriod.length > 0) {
        await selectedTimePeriod.map((val: any) => {
          timeArr.push(val.time_Period_Value);
        });
        time_period = timeArr.join(", ");
      }

      let moduleNumber = getFNameVal
        ? getFNameVal.toLowerCase().replace("module", "")
        : "";

      let bodyObject = {
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        moduleKey: `${moduleNumber}`,
        constrain_Id: constrainId,
        criteria_1_Value: arrayCrit_1, //'VENDOR001', // arrayCrit_1,
        criteria_2_Type: getDynamicConstrainMain[objIndex]["criTypeName"]
          ? getDynamicConstrainMain[objIndex]["criTypeName"]
          : CritriaTwoTypeVal,
        criteria_2_Value: arrayCrit_2, // 'UPR01', //arrayCrit_2,
        symbol_Value: getDynamicConstrainMain[objIndex]["signValue"]
          ? getDynamicConstrainMain[objIndex]["signValue"]
          : "",
        cu: getDynamicConstrainMain[objIndex]["cu"]
          ? getDynamicConstrainMain[objIndex]["cu"]
          : "1",
        value: getDynamicConstrainMain[objIndex]["value"]
          ? getDynamicConstrainMain[objIndex]["value"]
          : 1,
        time_Period_Value: time_period ? time_period : "",
        criteria_1_Gurobi: arrayCrit_1 ? JSON.stringify(gurubiOne) : "",
        criteria_2_Gurobi: arrayCrit_2 ? JSON.stringify(gurubiTwo) : "",
      };

      await submitForm(bodyObject);

      setDisableSave(false);
    }
  };

  const submitForm = async (bodyObject: any) => {
    let responsedata: any = [];
    const urls = API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_SAVE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    setIsLoading(true);

    await postRequest(urls, bodyObject, header)
      .then((response: any) => {
        if (response.status === 200 && response.data) {
          responsedata = response.data;
          handleGetAllConstarins();
          handleCloseCreate();
          successMessagehandler("Successfully created");
          ClearInitialValues();
        }
      })
      .catch((error) => {
        handleCloseCreate();
        errorMessagehandler();
      });
  };

  const handleDeleteinAdd = (index: any) => {
    let arr: any = getDynamicConstrainMain;
    var filtered = arr.filter((el: any, ind: any) => {
      return ind != index;
    });
    setDynamicConstrainMain(filtered);
  };

  // delete in home view

  const [openDelete, setOpenDelete] = React.useState(false);

  const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleClickOpenDelete = (id: any) => {
    setOpenDelete(true);
    deleteInMainId = id;
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    deleteInMainId = "";
  };

  // Downloads the same template file for dynamic constraint upload
  const handleTemplateDownload = () => {
    const urls = API_BASE_URL + DOWNLOAD_DC_TEMPLATE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: {},
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, "DynamicConstraint_Template.xlsx");
    });
  };

  const DeleteInMain = () => {
    return (
      <React.Fragment>
        <Dialog
          open={openDelete}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseDelete}
          aria-describedby="alert-dialog-slide-description"
        >
          {/* <DialogTitle>{'Delete Constrains confirmation'}</DialogTitle> */}
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Confirmation for Delete
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Do you want to delete this constraint?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteMain}>Yes</Button>
            <Button onClick={handleCloseDelete}>No</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  };

  const handleDeleteMain = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    let getFNameVal: any = gerFolderName();
    let folderModuleName = selectedFolderData?.folder?.slice(0, 7);

    let moduleNumber = getFNameVal
      ? getFNameVal
      : folderModuleName
        ? folderModuleName
        : "";

    const requestParam = {
      scenariodccId: deleteInMainId,
      moduleKey: moduleNumber,
    };
    const urls =
      API_BASE_URL +
      LONG_DYNAMIC_CONSTRAINS_DELETE_API +
      `?scenariodccId=${deleteInMainId}&moduleKey=${moduleNumber}`;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    await deleteRequest(urls, requestParam, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsLoading(false);
          handleGetAllConstarins();
          successMessagehandler("Successfully deleted");
        }
      })
      .catch((error) => {
        errorMessagehandler();
      });
  };

  // edit flow

  const UpdateConstrainForm = async (bodyObject: any) => {
    let responsedata: any = [];
    const urls = API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_UPDATE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    setIsLoading(true);

    await putRequest(urls, bodyObject, header)
      .then((response: any) => {
        if (response.status === 200 && response.data) {
          responsedata = response.data;
          handleGoBackFromEdit();
          successMessagehandler("Successfully Updated");
          ClearInitialValues();
        }
      })
      .catch((error) => {
        handleCloseCreate();
        errorMessagehandler();
      });
  };

  const getC1CodeForEdit = () => {
    let arrayCrit_1 = "";
    let gurubi1Flag = "";

    // codes for crit 1

    let vc = "Vendor_Code";
    let ppc = "Processing_Plant_Code";
    let dlc = "Demand_Location_Code";
    let pacc = "Packaging_Plant_Code";

    if (editedC1Array && editedC1Array.length !== 0) {
      arrayCrit_1 = editedC1Array
        .map((e: any) => {
          let body;
          let value1 = e.criteria_1_Value;
          if (value1.includes(vc)) {
            body = value1.replace("Vendor_Code:", "");
            gurubi1Flag = vc;
          } else if (value1.includes(ppc)) {
            body = value1.replace("Processing_Plant_Code:", "");
            gurubi1Flag = ppc;
          } else if (value1.includes(dlc)) {
            body = value1.replace("Demand_Location_Code:", "");
            gurubi1Flag = dlc;
          } else if (value1.includes(pacc)) {
            body = value1.replace("Packaging_Plant_Code:", "");
            gurubi1Flag = pacc;
          } else {
            body = value1;
          }
          return body;
        })
        .join(",");

      let C1Gub = arrayCrit_1.split(",");
      return C1Gub;
    }
  };

  const UpdateContrain = () => {
    if (!getSignName) {
      setSnackbar({
        children: "Please choose a Sign value..!",
        severity: "error",
      });
    } else {
      setIsLoading(true);
      const objIndex = 0;

      let getFNameVal = gerFolderName();
      let arrayCrit_1 = "";
      let arrayCrit_2 = "";
      let time_period = "";
      let gurubi1Flag = "";
      let gurubi2Flag = "";
      let gurubiOne: any = {};
      let gurubiTwo: any = {};

      // codes for crit 1

      let vc = "Vendor_Code";
      let ppc = "Processing_Plant_Code";
      let dlc = "Demand_Location_Code";
      let pacc = "Packaging_Plant_Code";

      if (editedC1Array && editedC1Array.length !== 0) {
        arrayCrit_1 = editedC1Array
          .map((e: any) => {
            let body;
            let value1 = e.criteria_1_Value;
            if (value1.includes(vc)) {
              body = value1.replace("Vendor_Code:", "");
              gurubi1Flag = vc;
            } else if (value1.includes(ppc)) {
              body = value1.replace("Processing_Plant_Code:", "");
              gurubi1Flag = ppc;
            } else if (value1.includes(dlc)) {
              body = value1.replace("Demand_Location_Code:", "");
              gurubi1Flag = dlc;
            } else if (value1.includes(pacc)) {
              body = value1.replace("Packaging_Plant_Code:", "");
              gurubi1Flag = pacc;
            } else {
              body = value1;
            }
            return body;
          })
          .join(",");

        let C1Gub = arrayCrit_1.split(",");
        if (gurubi1Flag) {
          gurubiOne[gurubi1Flag] = C1Gub;
        }
      }

      let fc = "Facility_Code";
      let rpmc = "RM_PM_MI_Code";
      let dml = "Demand_location_Code";
      let ccd = "Cascade";
      let sfgc = "SFG_Code";
      let pc = "Product_Code";

      if (editedC2Array && editedC2Array.length !== 0) {
        arrayCrit_2 = editedC2Array
          .map((e: any) => {
            let body;
            let value = e.criteria_2_Value;
            if (value.includes(fc)) {
              body = value.replace("Facility_Code:", "");
              gurubi2Flag = fc;
            } else if (value.includes(rpmc)) {
              body = value.replace("RM_PM_MI_Code:", "");
              gurubi2Flag = rpmc;
            } else if (value.includes(dml)) {
              body = value.replace("Demand_location_Code:", "");
              gurubi2Flag = dml;
            } else if (value.includes(ccd)) {
              body = value.replace("Cascade:", "");
              gurubi2Flag = ccd;
            } else if (value.includes(sfgc)) {
              body = value.replace("SFG_Code:", "");
              gurubi2Flag = sfgc;
            } else if (value.includes(pc)) {
              body = value.replace("Product_Code:", "");
              gurubi2Flag = pc;
            } else {
              body = value;
            }
            return body;
          })
          .join(",");

        let C2Gub = arrayCrit_2.split(",");
        if (gurubi2Flag) {
          gurubiTwo[gurubi2Flag] = C2Gub;
        }
      }
      let timeArr: any = [];
      if (editedTimeArray && editedTimeArray.length > 0) {
        editedTimeArray.map((val: any) => {
          timeArr.push(val.time_Period_Value);
        });
        time_period = timeArr.join(", ");
      }

      let moduleNumber = getFNameVal
        ? getFNameVal.toLowerCase().replace("module", "")
        : "";

      let bodyObject = {
        scenariodccId: setCcidForEdit,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        moduleKey: `${moduleNumber}`,
        constrain_Id: constrainId,
        criteria_1_Value: arrayCrit_1, //'VENDOR001', // arrayCrit_1,
        criteria_2_Type: getDynamicConstrainMain[objIndex]["criTypeName"]
          ? getDynamicConstrainMain[objIndex]["criTypeName"]
          : CritriaTwoTypeVal,
        criteria_2_Value: arrayCrit_2, //'UPR01', //arrayCrit_2,
        symbol_Value: getDynamicConstrainMain[objIndex]["signValue"]
          ? getDynamicConstrainMain[objIndex]["signValue"]
          : "",
        cu: getDynamicConstrainMain[objIndex]["cu"]
          ? getDynamicConstrainMain[objIndex]["cu"]
          : "1",
        value: getDynamicConstrainMain[objIndex]["value"]
          ? getDynamicConstrainMain[objIndex]["value"]
          : 1,
        time_Period_Value: time_period ? time_period : "",
        criteria_1_Gurobi: arrayCrit_1 ? JSON.stringify(gurubiOne) : "",
        criteria_2_Gurobi: arrayCrit_2 ? JSON.stringify(gurubiTwo) : "",
      };

      UpdateConstrainForm(bodyObject);
    }
  };

  // const handleChangeCriteriaOneForEdit = (editedArray: any) => {
  //   setCriteriaOneEdited(editedArray);
  // };

  const handleChangeCriteriaTwoForEdit = (editedArray: any) => {
    setCriteriaTwoEdited(editedArray);
  };

  const handleChangeTimePeriodForEdit = (editedArray: any) => {
    setTimePeriodEdited(editedArray);
  };
  const getDifferenceC1 = (array1: any, array2: any) => {
    if (array1.length != 0 && array2.length != 0) {
      return array1.filter((object1: any) => {
        return array2.some((object2: any) => {
          return object1.criteria_1_Value.includes(object2.trim());
        });
      });
    }
  };

  const getDifferenceC2 = (array1: any, array2: any) => {
    if (array1.length != 0 && array2.length != 0) {
      return array1.filter((object1: any) => {
        return array2.some((object2: any) => {
          return object1.criteria_2_Value.includes(object2.trim());
        });
      });
    }
  };

  const getDifferenceTp = (array1: any, array2: any) => {
    if (array1.length != 0 && array2.length != 0) {
      return array1.filter((object1: any) => {
        return array2.some((object2: any) => {
          return object1.time_Period_Value.includes(object2.trim());
        });
      });
    }
  };

  const CheckboxesTagsCriteriaOneForEdit = (criteriaOneObj: any) => {
    criteriaDisable = false;
    let criteriaOneData = criteriaOneObj.criteriaOne;
    let criteriaOneV = criteriaOneObj.criteriaOneV;
    if (criteriaOneData) {
      let checkNa = criteriaOneData[0];

      if (checkNa?.criteria_2_Value == "NA") {
        criteriaDisable = true;
      }
    }
    if (criteriaOneData.length == 0) {
      criteriaDisable = true;
    }

    let checkedArry = getDifferenceC1(criteriaOneData, criteriaOneV);

    // preselect check

    return (
      <Autocomplete
        multiple
        id="checkboxes-tags-demo-new"
        options={criteriaOneData}
        limitTags={1}
        onChange={(event, newValue) => {
          editedC1Array = newValue;
        }}
        disabled={criteriaDisable}
        ref={autoClearCriteriaOne}
        autoComplete
        includeInputInList
        disableCloseOnSelect
        getOptionLabel={(option: any) => option.criteria_1_Key}
        defaultValue={editedC1Array || checkedArry}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select Criteria 1"
            fullWidth
          />
        )}
      />
    );
  };

  const CheckboxesTagsCriteriaTwoTypeForEdit = (
    templateData: any,
    index: any,
    nameTemplateData: any,
  ) => {
    criteriaDisable = false;
    if (templateData) {
      let checkNa = templateData[0];

      if (checkNa?.criteria_2_Value == "NA") {
        criteriaDisable = true;
      }
    }
    if (templateData.length == 0) {
      criteriaDisable = true;
    }
    return (
      <Select
        id="simple-select-constrain"
        value={nameTemplateData}
        disabled={criteriaDisable}
        onChange={(event) => handleCriteriaType2Data(event, index)}
        inputProps={{ "aria-label": "Without label" }}
        displayEmpty
      >
        <MenuItem>
          <em>Select Constraint Type</em>
        </MenuItem>
        {templateData.map((d: any, ind: any) => {
          return (
            <MenuItem
              key={`cont-list-type-${ind}`}
              id={ind}
              onClick={(e) =>
                handleCriteriaType2DataClickEdit(
                  e,
                  d.criteria_2_Key,
                  d.criteria_2_Value,
                )
              }
              value={d.criteria_2_Value}
            >
              {d.criteria_2_Value}
            </MenuItem>
          );
        })}
      </Select>
    );
  };

  const CheckboxesTagsCriteriaTwoForEdit = (criteriaOneObj: any) => {
    let disable = false;
    let criteriaTwoData = criteriaOneObj.criteriaTwo;
    let criteriaTwoV = criteriaOneObj.criteriaTwoV;

    if (criteriaTwoData) {
      let checkNa = criteriaTwoData[0];

      if (checkNa?.criteria_2_Value == "NA") {
        disable = true;
      }
    }
    if (criteriaTwoData.length == 0) {
      disable = true;
    }

    let checkedArry = getDifferenceC2(criteriaTwoData, criteriaTwoV);

    return (
      <Autocomplete
        multiple
        id="checkboxes-tags-demo-new"
        options={criteriaTwoData}
        limitTags={1}
        disabled={criteriaDisable || disable}
        onChange={(event, newValue) => {
          editedC2Array = newValue;
        }}
        ref={autoClearCriteriaTwo}
        // disabled={!inputValue ? true : false}
        autoComplete
        includeInputInList
        defaultValue={editedC2Array || checkedArry}
        disableCloseOnSelect
        getOptionLabel={(option: any) => option.criteria_2_Key}
        // style={{ width: 500 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select Criteria 2"
            fullWidth
          />
        )}
      />
    );
  };

  // fetch data for edit flow

  const handleGetEditData = async (ccid: any, ConstId: any) => {
    setIsLoading(true);
    // get f name

    let fname = gerFolderName();

    if (fname == null || fname == undefined) {
      return;
    }

    if (fname !== null) {
      const urls = API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_UPDATE_BY_ID_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      let getFNameVal = gerFolderName();
      let moduleNumber = getFNameVal
        ? getFNameVal.toLowerCase().replace("module", "")
        : "";

      let bodyObject = {
        scenariodccId: ccid,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        moduleKey: `${moduleNumber}`,
      };

      await postRequest(urls, bodyObject, header)
        .then((response: any) => {
          if (response.status === 200 && response.data) {
            let responseData = response.data;
            setDataForEdit(responseData);
            getCriteriaModuleDetailsForEdit(ConstId, responseData[0]);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          errorMessagehandler();
        });
    }
  };

  const handleClickOpenEdit = async (ccId: any, ConstId: any) => {
    setAllConstarins([]);
    setHeadingName("");
    setCcidForEdit = ccId;

    if (getAllConstarins && getAllConstarins.length > 0) {
      await handleGetEditData(ccId, ConstId);
    }
  };

  const TimePeriodDataForEdit = (timePeriodObj: any) => {
    let timePeriodData = timePeriodObj?.time_Period
      ? timePeriodObj?.time_Period
      : [];
    let timePeriodDataValue = timePeriodObj?.time_PeriodV
      ? timePeriodObj?.time_PeriodV
      : "";

    let disable = false;
    if (timePeriodData) {
      let checkNa = timePeriodData[0];

      if (checkNa?.criteria_2_Value == "NA") {
        disable = true;
      }
    }
    if (timePeriodData.length == 0) {
      disable = true;
    }

    let checkedArry = getDifferenceTp(timePeriodData, timePeriodDataValue)
      ? getDifferenceTp(timePeriodData, timePeriodDataValue)
      : [];

    return (
      <Autocomplete
        multiple
        id="checkboxes-tags-demo-new"
        options={timePeriodData}
        limitTags={1}
        disableCloseOnSelect
        onChange={(event, newValue) => {
          editedTimeArray = newValue;
        }}
        defaultValue={editedTimeArray || checkedArry}
        disabled={disable}
        ref={autoClearTimePeriod}
        autoComplete
        includeInputInList
        getOptionLabel={(option: any) => option.time_Period_Key}
        // style={{ width: 500 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select TimePeriod"
            fullWidth
          />
        )}
      />
    );
  };

  // Function to update an object in the array based on the id
  const updateCTObject = (array: any, updatedProperties: any) => {
    return array.map((obj: any) => {
      return {
        ...obj, // Spread the existing object
        ...updatedProperties, // Spread the updated properties
      };
    });
  };

  const getAllWithC1AndCtypwForEdit = async (key: any, val: any) => {
    setIsLoading(true);
    let getFNameVal = gerFolderName();

    let getC1;
    if (editedC1Array) {
      getC1 = getC1CodeForEdit();
    }

    if (key && val && getFNameVal && selectedFolderId) {
      let bodyObject = {
        folder_id: selectedFolderId, //4
        scenario_id: selectedScenarioId, //27
        moduleKey: `${getFNameVal}`,
        constrain_Id: constrainId,
        criteria_1_Value: getC1 ? getC1.join(",") : val, //'VENDOR001', // array,
        criteria_2_Type: key,
        criteria_2_Value: "",
      };

      let responsedata: any = [];
      const urls =
        API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_GETALL_CR1WITHTYPE_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      await postRequest(urls, bodyObject, header)
        .then((response: any) => {
          if (response.status === 200 && response.data) {
            responsedata = response.data;
            setIsLoading(false);
          }
        })
        .catch((error) => {
          errorMessagehandler();
        });

      criteria2Edit = responsedata.criteriaTwo ? responsedata.criteriaTwo : [];
      time_PeriodEdit = responsedata.time_Period
        ? responsedata.time_Period
        : [];
      const updatedArray = updateCTObject(getDynamicConstrainMain, {
        criteriaTwo: criteria2Edit,
        time_Period: time_PeriodEdit,
        criTypeName: val,
      });
      setDynamicConstrainMain(updatedArray);
    }
    setIsLoading(false);
  };

  // Function to handle focus
  const handleFocus = (fieldName: any) => {
    setFocusedField(fieldName);
  };

  const getCriteriaModuleDetailsForEdit = async (
    lableId: any,
    editObject: any,
  ) => {
    setIsLoading(true);
    let getFNameVal = gerFolderName();
    constrainId = lableId;

    if (lableId && getFNameVal) {
      let bodyObject = {
        folder_id: selectedFolderId, // 4
        scenario_id: selectedScenarioId, //27
        moduleKey: `${getFNameVal}`,
        constrain_Id: lableId,
      };

      let responsedata: any = [];
      const urls = API_BASE_URL + LONG_DYNAMIC_CONSTRAINS_CRITERIA_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      await postRequest(urls, bodyObject, header)
        .then((response: any) => {
          if (response.status === 200 && response.data) {
            responsedata = response.data;
            setIsLoading(false);
            setHeadingName("Edit Constraint");
            setOpenEdit(true);
            setEmptyPage(false);
          }
        })
        .catch((error) => {
          errorMessagehandler();
        });

      //find the index of object from array that you want to update
      const objIndex = 0;

      // crit 1

      let c1Str =
        editObject.criteria_1_Value != "" ? editObject.criteria_1_Value : null;
      let c1Array = c1Str ? c1Str.split(",") : null;

      // crit 2

      let c2Str =
        editObject.criteria_2_Value != "" ? editObject.criteria_2_Value : null;
      let c2Array = c2Str ? c2Str.split(",") : null;

      // time period

      let timePeriod =
        editObject.time_Period_Value != ""
          ? editObject.time_Period_Value
          : null;
      let timePeriodArray = timePeriod ? timePeriod.split(",") : null;

      // fetch criteria 2 values

      let typeVal = editObject.criteria_2_Type_Value;
      let c1arr = editObject.criteria_1_Value;
      if (typeVal && c1arr) {
        await getAllWithC1AndCtypwForEdit(typeVal, c1arr);
      }

      // // make new object of updated object.
      const updatedObj = {
        ...getDynamicConstrainMain[objIndex],
        criteriaOne: responsedata.criteriaOne ? responsedata.criteriaOne : [],
        criteriaOneV: c1Array ? c1Array : [],
        criteriaTwo: criteria2Edit
          ? criteria2Edit
          : responsedata.criteriaTwo
            ? responsedata.criteriaTwo
            : [],
        criteriaTwoV: c2Array ? c2Array : [],
        criteriaTwoType: responsedata.criteriaTwo_Type
          ? responsedata.criteriaTwo_Type
          : [],
        criTypeName: editObject.criteria_2_Type_Value
          ? editObject.criteria_2_Type_Value
          : "",
        cuFlag: responsedata.cuFlag ? responsedata.cuFlag : [],
        sign: responsedata.sign ? responsedata.sign : "",
        signValue: editObject.symbol_Value ? editObject.symbol_Value : "",
        time_Period: time_PeriodEdit
          ? time_PeriodEdit
          : responsedata.time_Period
            ? responsedata.time_Period
            : [],
        time_PeriodV: timePeriodArray ? timePeriodArray : [],
        contstrainValue: editObject.constrainName
          ? editObject.constrainName
          : "",
        value: editObject.value ? editObject.value : "",
        cu: editObject.cu ? editObject.cu : "",
      };

      //set initial values

      let c1Init = [];
      let c2Init = [];
      let timePeriodInit = [];
      //set sign value

      let initSignValue = editObject.symbol_Value
        ? editObject.symbol_Value
        : "";

      setSignName(initSignValue);

      if (responsedata.criteriaOne && c1Array) {
        c1Init = getDifferenceC1(responsedata.criteriaOne, c1Array);
      }
      let cri2arr = criteria2Edit
        ? criteria2Edit
        : responsedata.criteriaTwo
          ? responsedata.criteriaTwo
          : [];
      if (cri2arr && c2Array) {
        c2Init = getDifferenceC2(cri2arr, c2Array);
      }

      let timeePee = time_PeriodEdit
        ? time_PeriodEdit
        : responsedata.time_Period
          ? responsedata.time_Period
          : [];

      if (timeePee && timePeriodArray) {
        timePeriodInit = getDifferenceTp(timeePee, timePeriodArray);
      }
      editedC1Array = c1Init;
      editedC2Array = c2Init;
      editedTimeArray = timePeriodInit;
      // setCriteriaOneEdited(c1Init);
      // setCriteriaTwoEdited(c2Init);
      // setTimePeriodEdited(timePeriodInit);

      // make final new array of objects by combining updated object.
      const updatedProjects: any = [
        ...getDynamicConstrainMain.slice(0, objIndex),
        updatedObj,
        ...getDynamicConstrainMain.slice(objIndex + 1),
      ];

      // let addNewConstrains = getDynamicConstrainMain.concat(updatedProjects)

      setDynamicConstrainMain(updatedProjects);
    }
  };

  const SignNamesForEdit = (getSignNameData: any, index: any) => {
    let signArray: any = getSignNameData?.sign ? getSignNameData?.sign : [];
    return (
      <Select
        id="simple-select-constrain"
        value={getSignNameData.signValue}
        onChange={(e) => handleSignData(e, index)}
        inputProps={{ "aria-label": "Without label" }}
        displayEmpty
      >
        <MenuItem>
          <em>Select Sign</em>
        </MenuItem>
        {signArray.map((d: any, ind: any) => {
          return (
            <MenuItem key={`sign-list-${ind}`} value={d.symbol_Key}>
              {d.symbol_Key}
            </MenuItem>
          );
        })}
      </Select>
    );
  };

  const EditConstraint = () => {
    return (
      <div className="constains-parent-container">
        <table className="constrains-table" cellPadding={0} cellSpacing={0}>
          <tr className="edit-wrap">
            <th>Constraint Name</th>
            <th>Criteria 1</th>
            <th>Criteria 2 Type</th>
            <th>Criteria 2</th>
            <th>Sign</th>
            <th>Value</th>
            <th>CU</th>
            <th>Time Period</th>
          </tr>

          {getDynamicConstrainMain?.map((templateData: any, index: any) => {
            return (
              <tr key={`disp-main-edit-list-${index}`}>
                <td>
                  <FormControl sx={{ m: 1, width: 200 }}>
                    {templateData.contstrainValue}
                  </FormControl>
                </td>
                <td>
                  <FormControl sx={{ m: 1, width: 200 }}>
                    {CheckboxesTagsCriteriaOneForEdit(templateData)}
                  </FormControl>
                </td>
                <td>
                  <FormControl sx={{ m: 1, width: 170 }}>
                    {CheckboxesTagsCriteriaTwoTypeForEdit(
                      templateData?.criteriaTwoType,
                      index,
                      templateData?.criTypeName,
                    )}
                  </FormControl>
                </td>
                <td>
                  <FormControl sx={{ m: 1, width: 220 }}>
                    {CheckboxesTagsCriteriaTwoForEdit(templateData)}
                  </FormControl>
                </td>
                <td>
                  <FormControl sx={{ m: 1, width: 120 }}>
                    {SignNamesForEdit(templateData, index)}
                  </FormControl>
                </td>

                <td>
                  <FormControl sx={{ m: 1, width: "20ch" }} variant="outlined">
                    <TextField
                      id="val-data-edit"
                      aria-describedby="outlined-weight-helper-text"
                      // value={getValueName}
                      value={templateData.value}
                      onChange={(e) => handleValueChange(e, index)}
                      placeholder="Enter Value"
                      type="number"
                      onFocus={() => handleFocus("val-data-edit")}
                      autoFocus={focusedField === "val-data-edit"}
                    />
                  </FormControl>
                </td>
                <td>
                  <FormControl sx={{ m: 1, width: "20ch" }} variant="outlined">
                    <TextField
                      id="cu-data-edit"
                      aria-describedby="outlined-weight-helper-text"
                      // value={getCuName}
                      //disabled={templateData.cu}
                      value={templateData.cu}
                      onChange={(e) => handleCuChange(e, index)}
                      placeholder="Enter Value"
                      type="number"
                      onFocus={() => handleFocus("cu-data-edit")}
                      autoFocus={focusedField === "cu-data-edit"}
                    />
                  </FormControl>
                </td>
                <td>
                  <FormControl sx={{ m: 1, width: 165 }}>
                    {TimePeriodDataForEdit(templateData)}
                  </FormControl>
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    );
  };

  // save flow

  const handleCloseCreate = () => {
    setOpenEdit(false);
  };

  // go back

  const ClearInitialValues = () => {
    contstrainNameValue = "";
    isContstrainNameChanged = true;
    CritriaTwoTypeVal = "";
    criteriaDisable = false;
    constrainId = "";
    deleteInMainId = "";
    editedC1Array = [];
    editedC2Array = [];
    editedTimeArray = [];
    setCcidForEdit = "";
    criteria2Edit = [];
    time_PeriodEdit = [];
    setDynamicConstrainMain(initialStateArr);
    setSelectedCritriaOne([]);
    setSelectedCritriaTwo([]);
    setSelectedTimePeriod([]);
    setSignName("");
  };

  const handleGoBackFromEdit = () => {
    ClearInitialValues();
    setHeadingName("");

    setOpenEdit(false);
    // setEmptyPage(true);
    handleGetAllConstarins();
  };

  const handleGoBackFromCreate = async () => {
    // setOpenEdit(false);
    ClearInitialValues();
    await handleGetAllConstarins();
    // if (getAllConstarins && getAllConstarins.length == 0) {
    //   setEmptyPage(true);
    //   setNewAddData(false);
    //   setHeadingName('Dynamic Constrains');
    // } else {
    //   setEmptyPage(false);
    // }
  };

  const columns = [
    {
      field: "constrainName",
      headerName: "Constraint Name",
      width: 160,
      editable: false,
      hideable: false,
      sortable: false,
    },
    {
      field: "criteria_1_Value",
      headerName: "Criteria 1",
      width: 200,
      editable: false,
      hideable: false,
      sortable: false,
    },
    {
      field: "criteria_2_Type_Value",
      headerName: "Criteria 2 Type",
      width: 200,
      editable: false,
      hideable: false,
      sortable: false,
    },
    {
      field: "criteria_2_Value",
      headerName: "Criteria 2",
      hideable: false,
      sortable: false,
      width: 140,
      editable: false,
    },
    {
      field: "symbol_Value",
      headerName: "Sign",
      editable: false,
      hideable: false,
      sortable: false,
      width: 140,
    },
    {
      field: "value",
      headerName: "Value",
      editable: false,
      hideable: false,
      sortable: false,
      width: 140,
    },
    {
      field: "cu",
      headerName: "CU",
      hideable: false,
      sortable: false,
      width: 140,
    },
    {
      field: "time_Period_Value",
      headerName: "Time Period",
      hideable: false,
      sortable: false,
      width: 140,
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 150,
      renderCell: (params: any) => {
        // console.log(params, '+++++++++++++++++++++++++++++++params');
        return (
          <FormControl sx={{ m: 1, width: 165 }}>
            <div className="action-btn">
              <span
                title="Delete"
                onClick={() => handleClickOpenDelete(params.row.scenariodccId)}
              >
                <DeleteIcon className="delete-contrain" />
              </span>
              <span
                title="Edit"
                className="edit-mg"
                onClick={() =>
                  handleClickOpenEdit(
                    params.row.scenariodccId,
                    params.row.constrainId,
                  )
                }
              >
                <EditIcon className="edit-contrain" />
              </span>
            </div>
          </FormControl>
        );
      },
    },
  ];

  const tableData = {
    columns: columns,
    rows: getAllConstarins,
    initialState: {
      columns: {
        columnVisibilityModel: {
          id: false,
        },
      },
    },
    experimentalFeatures: {
      ariaV7: true,
    },
  };

  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <MuiPagination
        color="primary"
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
      />
    );
  }

  const CustomPagination = (props: any) => {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
  };
  const MyCustomNoRowsOverlay = () => (
    <div className="nodata-display-lable">No Data to Display.</div>
  );

  const DisplayAllConstarins = () => {
    return (
      <div>
        <Box sx={{ width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.scenariodccId}
            editMode="row"
            {...tableData}
            initialState={{
              ...tableData.initialState,
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            pageSizeOptions={[10, 25, 50, 100]}
            showColumnVerticalBorder
            showCellVerticalBorder
            disableColumnSelector
            disableColumnMenu
            pagination
            slots={{
              pagination: CustomPagination,
              noRowsOverlay: MyCustomNoRowsOverlay,
              //toolbar: CustomToolbar,
            }}
            hideFooterSelectedRowCount
            disableRowSelectionOnClick
            className="data-grid-mui"
          />
        </Box>
      </div>
    );
  };

  return (
    <div className="Compare">
      <div className="filter-section">
        <div className="page-title">
          <h3>{headingName}</h3>
        </div>
        <div>
          {
            <button
              onClick={() => handleTemplateDownload()}
              className="constrains-btn-download constrains-btn-main"
            >
              <img src={DownloadIcon} alt="downloadIcon" />
              Download Template
            </button>
          }
          {getAllConstarins && getAllConstarins.length > 0 && (
            <>
              <Button
                variant="outlined"
                className="upload-constraints-btn"
                onClick={handleUploadConstraintClick}
              >
                <img src={ExcelIcon} alt="ExcelIcon" />
                {"Upload Constraints"}
              </Button>
              <input
                type="file"
                ref={hiddenFileInput}
                style={{ display: "none" }}
                onChange={handleUploadConstraintFile}
              />
              <button
                onClick={() => toggleDisplay(true)}
                className="constrains-btn constrains-btn-main"
              >
                Add Constraint <span className="pluss-icon">+</span>
              </button>
            </>
          )}

          {openEdit && (
            <span>
              <button
                onClick={() => UpdateContrain()}
                className="constrains-btn constrains-btn-main"
              >
                Update Constraint
              </button>
              <Tooltip title="Go Back">
                <IconButton
                  onClick={handleGoBackFromEdit}
                  color="primary"
                  aria-label="add to shopping cart"
                >
                  <ArrowBackIosIcon />
                </IconButton>
              </Tooltip>
            </span>
          )}
        </div>

        {getNewAddData && (
          <div>
            <span>
              <button
                className="constrains-btn-save"
                onClick={handleSaveConstraint}
              >
                <img src={btnSaveIcon} alt="" /> <span> Save</span>
              </button>
            </span>
            <span>
              <Tooltip title="Go Back">
                <IconButton
                  onClick={handleGoBackFromCreate}
                  color="primary"
                  aria-label="add to shopping cart"
                >
                  <ArrowBackIosIcon />
                </IconButton>
              </Tooltip>
            </span>
          </div>
        )}
      </div>

      {/* show all records */}

      {getAllConstarins && getAllConstarins.length > 0 && (
        <div>
          <DisplayAllConstarins />
        </div>
      )}

      {/* Main empty page */}

      {showEmptyPage && (
        <div className="constains-parent-container">
          <table className="constrains-table" cellPadding={0} cellSpacing={0}>
            <tr>
              <th>Constraint Name</th>
              <th>Criteria 1</th>
              <th>Criteria 2</th>
              <th>Sign</th>
              <th>Value</th>
              <th>CU</th>
              <th>Time Period</th>
            </tr>
          </table>
          <br></br>
          <div className="create-constrains-block">
            <h4> Add Constraint</h4>
            <span className="sub-text">
              You can start adding contraints by clicking the <br></br>
              below button
            </span>
            <br></br>
            <br></br>

            <button
              className="constrains-btn"
              onClick={() => toggleDisplay(false)}
            >
              Add Constraint <span className="plus-icon">+</span>
            </button>
            <p>OR</p>

            <Button
              variant="outlined"
              className="upload-constraints-btn"
              onClick={handleUploadConstraintClick}
            >
              <img src={ExcelIcon} alt="ExcelIcon" />
              {"Upload Constraints"}
            </Button>
            <input
              type="file"
              ref={hiddenFileInput}
              style={{ display: "none" }}
              onChange={handleUploadConstraintFile}
            />
          </div>
        </div>
      )}

      {/* create flow */}

      {getNewAddData && (
        <div className="constains-parent-container">
          <table className="constrains-table" cellPadding={0} cellSpacing={0}>
            <tr>
              <th>Constraint Name</th>
              <th>Criteria 1</th>
              <th>Criteria 2 Type</th>
              <th>Criteria 2</th>
              <th>Sign</th>
              <th>Value</th>
              <th>CU</th>
              <th>Time Period</th>
              {/* <th>Action</th> */}
            </tr>
            {getDynamicConstrainMain?.map((templateData: any, index: any) => {
              return (
                <tr key={`disp-main-list-${index}`}>
                  <td>
                    <FormControl sx={{ m: 1, minWidth: 200 }}>
                      {SelectContstrain(
                        templateData?.contstrainNames,
                        index,
                        templateData?.contstrainValue,
                      )}
                    </FormControl>
                  </td>
                  <td>
                    <FormControl sx={{ m: 1, width: 200 }}>
                      {CheckboxesTagsCriteriaOne(templateData?.criteriaOne)}
                    </FormControl>
                  </td>
                  <td>
                    <FormControl sx={{ m: 1, width: 170 }}>
                      {CheckboxesTagsCriteriaTwoType(
                        templateData?.criteriaTwoType,
                        index,
                        templateData?.criTypeName,
                      )}
                    </FormControl>
                  </td>
                  <td>
                    <FormControl sx={{ m: 1, width: 220 }}>
                      {CheckboxesTagsCriteriaTwo(templateData?.criteriaTwo)}
                    </FormControl>
                  </td>
                  <td>
                    <FormControl sx={{ m: 1, width: 120 }}>
                      {SignNames(templateData?.sign, index)}
                    </FormControl>
                  </td>

                  <td>
                    <FormControl
                      sx={{ m: 1, width: "20ch" }}
                      variant="outlined"
                    >
                      <TextField
                        id="val-data"
                        aria-describedby="outlined-weight-helper-text"
                        // value={getValueName}
                        value={templateData.value}
                        onChange={(e) => handleValueChange(e, index)}
                        placeholder="Enter Value"
                        type="number"
                      />
                    </FormControl>
                  </td>
                  <td>
                    <FormControl
                      sx={{ m: 1, width: "20ch" }}
                      variant="outlined"
                    >
                      <TextField
                        id="cu-data"
                        aria-describedby="outlined-weight-helper-text"
                        // value={getCuName}
                        disabled={
                          templateData.cuFlag !== "NA" ||
                          templateData.cuFlag == ""
                            ? false
                            : true
                        }
                        value={templateData.cuFlag ? templateData.cuFlag : ""}
                        onChange={(e) => handleCuChange(e, index)}
                        placeholder="Enter Value"
                        type="number"
                      />
                    </FormControl>
                  </td>
                  <td>
                    <FormControl sx={{ m: 1, width: 165 }}>
                      {TimePeriodData(templateData?.time_Period)}
                    </FormControl>
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      )}

      {/* edit flow */}

      {openEdit && <EditConstraint />}

      {/* delete flow */}

      {openDelete && <DeleteInMain />}

      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}

      <Box sx={{ display: "flex" }}>
        {isLoading && <CircularProgress className="loaderr" color="primary" />}
      </Box>
    </div>
  );
}

export default DynamicConstrains;
